import { mapState, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
// import ApiManager from '@/utils/ApiManager'
// import Constants from '@/utils/Constants'

export default {
  name: 'PasswordConfirm',
  components: {
    Loading
  },
  data () {
    return {
      processing: false
    }
  },
  computed: {
    ...mapState({
      values: state => state.password.values
    }),
    maskedCurrentPassword () {
      return String('*').repeat(this.values.currentPassword.length)
    },
    maskedPassword () {
      return String('*').repeat(this.values.password.length)
    }
  },
  methods: {
    ...mapActions({
      signout: 'auth/signout',
      showError: 'error/show',
      showToast: 'toast/show'
    }),
    turnBack () {
      this.$router.go(-1)
    },
    postData () {
      this.processing = true

      let parameters = {
        PasswordData: {
          CurPassword: this.values.currentPassword,
          NewPassword: this.values.password
        }
      }
      console.log('register data', parameters)

      // // 登録
      // ApiManager.request(
      //   ['user'],
      //   ['v1UserPasswordUpdate'],
      //   [parameters])
      //   .then(res => {
      //     this.processing = false
      //     let status = Utility.parseResponse(res)

      //     if (status.result) {
      //       // toast
      //       this.showToast({
      //         title: 'パスワード変更',
      //         body: '新しいパスワードに変更しました。'
      //       })

      //       // 自動ログインの場合
      //       // this.$router.push({name: 'Home'})

      //       // 再度ログインさせる場合
      //       this.signout()
      //       this.$router.push({
      //         name: 'Signin'
      //       })

      //     } else if (status.error) {
      //       // エラーメッセージ表示
      //       this.showError(res)
      //     } else {
      //       // アプリケーションエラー表示
      //       this.showError(null)
      //     }
          
      //   })
      //   // eslint-disable-next-line
      //   .catch(error => {
      //     this.processing = false
      //     this.showError(null)
      //   })
    }
  }
}
